export const TI = () => `/ti`;
export const TIENVIOS = () => `/ti/envios`;
export const TIUSUARIOS = () => `/ti/usuarios`;
/**
 * Ficha do usuário (at-68). ⚠️ `/ti/usuarios/novo` precisa ser declarada ANTES de
 * `/ti/usuarios/:id` no `App.tsx`, senão "novo" é lido como um id.
 *
 * 📌 `TICRIARUSUARIO` (`/ti/criar-usuario`) **não existe mais**: criar e editar viraram
 * a mesma tela. Quem digitar o endereço antigo cai na Home pelo `path="*"`.
 */
export const TIUSUARIO_NOVO = () => `/ti/usuarios/novo`;
export const TIUSUARIO = (id: string = ':id') => `/ti/usuarios/${id}`;
export const TITERMOS = () => `/ti/termos`;
/**
 * Ficha do template de termo (at-69). O editor era um modal de 692 linhas com duas
 * abas, duas colunas e 850px de largura forçada no `style` — é uma tela, não um
 * diálogo (mesma decisão da ficha de usuário, at-68). URL própria dá "Voltar",
 * recarregar e link entre TIs, e a trava de fechamento com o `PUT` em voo deixa de
 * ser necessária por construção.
 */
export const TITERMO = (codigo: string = ':codigo') => `/ti/termos/${codigo}`;

export const TICRONS = () => `/ti/crons`;

/** Logs do Sistema (at-85, item 66) — TI e ADMIN. Entra no shell pelo prefixo `/ti`. */
export const TILOGS = () => `/ti/logs`;

export const TIPLANOS = () => `/ti/planos`;
/** Ficha do plano de cotação (at-69). ⚠️ 404 aqui é o modo de CRIAÇÃO (at-43). */
export const TIPLANO = (codigo: string = ':codigo') => `/ti/planos/${codigo}`;

export const TIBIKES = () => `/ti/bikes`;
/**
 * Ficha da motocicleta elétrica (at-69). ⚠️ `/ti/bikes/novo` precisa ser declarada
 * ANTES de `/ti/bikes/:id` no `App.tsx`, senão "novo" é lido como um id — a mesma
 * lição da at-68.
 */
export const TIBIKE_NOVO = () => `/ti/bikes/novo`;
export const TIBIKE = (id: string = ':id') => `/ti/bikes/${id}`;

export const TICONTRATOS = () => `/ti/contratos`;

/**
 * Exclusão definitiva de associado (at-77, item 64).
 *
 * 🔴 **Só ADMIN.** É a única tela do hub restrita a esse papel — a ação é
 * irreversível, apaga PII e remove arquivos do armazenamento. O card fica
 * escondido para TI, mas quem barra de verdade é o backend, com 403.
 */
export const TIEXPURGO = () => `/ti/expurgo`;
